module.exports = __webpack_public_path__ + "media/VideoTest.e43cbc10.mp4";